"use client";
import { jsx as n } from "react/jsx-runtime";
import { withCmsDataHandling as v } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import E from "../../layout/Container/Container.js";
import { Box as x, sharedHandler as C } from "@ingeniorforeningen/figurine-core";
import { forwardRef as _, useEffect as H } from "react";
import { embedDeliveryApiParser as N } from "./Embed.helpers.js";
import '../../../assets/Embed.css';const P = "_root_1nj2x_2", j = {
  root: P
}, d = _((r, s) => {
  const {
    title: m,
    src: l,
    width: c = "100%",
    height: p,
    allow: f,
    loading: h,
    name: u,
    referrerPolicy: y,
    sandbox: b,
    variant: t,
    ...w
  } = r, g = {
    title: m,
    allow: f,
    loading: h,
    name: u,
    referrerPolicy: y,
    sandbox: b
  };
  let a = l, i = c, o = p;
  return t === "playable" && (a = `https://ida.campaign.playable.com/${r.embedId}/?iframe=dontbreakout`, i = "100%", o = "500px"), t === "datawrapper" && (a = `//datawrapper.dwcdn.net/${r.embedId}`, i = "100%", o = "100%"), H(() => {
    const e = document.createElement("script");
    return t === "datawrapper" && (e.innerHTML = '!function(){"use strict";window.addEventListener("message",(function(e){if(void 0!==e.data["datawrapper-height"]){var t=document.querySelectorAll("iframe");for(var a in e.data["datawrapper-height"])for(var r=0;r<t.length;r++){if(t[r].contentWindow===e.source)t[r].style.height=e.data["datawrapper-height"][a]+"px"}}}))}();'), t === "playable" && (e.src = "https://zone-1.cdn.leadfamly.com/campaign/sdk/utilities.responsive_iframe.min.js", e.async = !0), e.async = !0, document.body.appendChild(e), () => {
      document.body.removeChild(e);
    };
  }, []), /* @__PURE__ */ n(E, { ref: s, ...w, size: "md", children: /* @__PURE__ */ n(
    x,
    {
      component: "iframe",
      ...g,
      src: a,
      className: j.root,
      width: i,
      height: o
    }
  ) });
});
d.displayName = "Embed";
const A = v({
  Component: C(d),
  deliveryApiParser: N
});
A.displayName = d.displayName;
export {
  j as E,
  d as _Embed,
  A as default
};
